import MetaSyncStatusPopover from "components/MetaSyncStatusPopover";
import RuvixxDate from "components/RuvixxDate";

// Muted last-synced sub-line for a Meta section group: the last-synced time, a
// "Never synced" placeholder, or "Syncing…" while a sync is in flight. The text
// stays faint so it reads as a sub-line rather than an alert; the outcome is
// reported calmly and per domain by the status popover rendered alongside it.
const MetaLastSynced = ({ lastSyncedAt, status, domains }) => {
  return (
    <span className="tw:flex tw:items-start tw:gap-1 tw:text-xs tw:text-[var(--color-text-secondary)]">
      <MetaSyncStatusPopover
        status={status}
        domains={domains}
        lastSyncedAt={lastSyncedAt}
      />
      {/* RuvixxDate renders its relative time in a block div; forcing descendants
          inline lets the label and time flow as one wrapping line instead of two
          side-by-side columns in the narrow rail. */}
      <span className="tw:min-w-0 tw:[&_div]:inline">
        {status === "pending" ? (
          "Syncing…"
        ) : lastSyncedAt ? (
          <>
            Last synced <RuvixxDate date={lastSyncedAt} />
          </>
        ) : (
          "Never synced"
        )}
      </span>
    </span>
  );
};

export default MetaLastSynced;
